import React from 'react'

const ThumbsUpIcon = () => {
  return (
    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="42" height="42" rx="21" fill="#C9FDE9"/>
<path d="M16.0658 17.999H11.125V27.9321H16.0658V17.999Z" fill="#26D894"/>
<path d="M22.0158 29.1271H25.4122C26.8555 29.1271 28.0829 28.1433 28.3968 26.7345L29.8002 20.4412C30.0034 19.5306 29.7852 18.5909 29.2015 17.8628C28.6181 17.135 27.7485 16.7175 26.8156 16.7175H22.7484L24.4045 12.1288C24.5651 11.6836 24.5411 11.2033 24.3366 10.7767C24.1322 10.3498 23.7732 10.0299 23.3255 9.876C22.9609 9.75107 22.5632 9.876 22.336 10.188L16.847 17.7354V28.0538L17.4479 28.2834C18.9118 28.8433 20.4487 29.1271 22.0158 29.1271Z" fill="#26D894"/>
</svg>

  )
}

export default ThumbsUpIcon

//url(#mask0_776_18137)
